import automaticOptimizationModule from "./automaticOptimizationModule"
import automaticOptimizationSearchView from "./automaticOptimizationSearch.html"
import automaticOptimizationEditionView from "./automaticOptimizationEdition.html"

automaticOptimizationModule.config(["$stateProvider", ($stateProvider) => {
    $stateProvider.state("r2.automaticOptimizationSearch", {
        data: {
            pageTitle: "{{'title.r2.automaticOptimization.search' | translate}}",
            group: "group.r2.cadastre.automaticOptimization"
        },
        url: "/automatic-optimization/",
        template: automaticOptimizationSearchView,
        controller: "automaticOptimizationControllerSearch"
    })
    .state("r2.newAutomaticOptimization", {
        data: {
            pageTitle: "{{'title.r2.newAutomaticOptimization' | translate}}",
            group: "group.r2.cadastre"
        },
        url: "/automaticOptimization/new",
        template: automaticOptimizationEditionView,
        controller: "automaticOptimizationControllerEdition",
        resolve: {
            automaticOptimizationConfig: function () {
                return null
            }
        }
    })
    .state("r2.editAutomaticOptimization", {
        url: "/automaticOptimization/edit/:automaticOptimizationId",
        template: automaticOptimizationEditionView,
        controller: "automaticOptimizationControllerEdition",
        data: {
            pageTitle: "{{'title.r2.newAutomaticOptimization' | translate}}",
            group: "group.r2.cadastre",
            dontRedirectOnForbidden: true
        },
        resolve: {
            automaticOptimizationConfig: ["$stateParams", "automaticOptimizationService", function ($stateParams, automaticOptimizationService) {
                return automaticOptimizationService.editAutomaticOptimizationConfig($stateParams.automaticOptimizationId)
                    .then(function(automaticOptimizationConfig){
                        return automaticOptimizationConfig
                    })
            }]
        },
        params: {
            reload: "true"
        }
    })
    .state("r2.copyAutomaticOptimization", {
        url: "/automaticOptimization/copy/:automaticOptimizationId",
        template: automaticOptimizationEditionView,
        controller: "automaticOptimizationControllerEdition",
        data: {
            pageTitle: "{{'title.r2.newAutomaticOptimization' | translate}}",
            group: "group.r2.cadastre",
            dontRedirectOnForbidden: true
        },
        resolve: {
            automaticOptimizationConfig: ["$stateParams", "automaticOptimizationService", function ($stateParams, automaticOptimizationService) {
                return automaticOptimizationService.copyAutomaticOptimizationConfig($stateParams.automaticOptimizationId)
                    .then(function(automaticOptimizationConfig){
                        return automaticOptimizationConfig
                })
            }]
        },
        params: {
            reload: "true"
        }
    })
}])